<template src="./RequestPasswordReset.html"></template>

<script lang="ts">
import { defineComponent } from "vue";
import AuthCard from "@/components/AuthCard";
import { accountModule } from "@/store/modules/account";
import { AccountActions } from "@/store/modules/account/actions";
import BaseDialog from "@/components/BaseDialog";
import FieldData from "@/services/fieldData";
import { Routes } from "@/router/routes";
import { notificationsModule } from "@/store/modules/notifications";
import { NotificationsActions } from "@/store/modules/notifications/actions";
import { AccountGetters } from "@/store/modules/account/getters";
import { VForm } from "vuetify/lib/components/VForm/VForm";

export default defineComponent({
    components: { AuthCard, BaseDialog },
    computed: {
        ...accountModule.mapGetters({
            loading: AccountGetters.Loading,
            errors: AccountGetters.Errors
        })
    },
    data() {
        return {
            emailData: new FieldData("Email address", {
                required: true,
                email: true
            }),
            email: "",
            informationDialog: false
        };
    },
    methods: {
        ...accountModule.mapActions({
            requestPasswordReset: AccountActions.RequestPasswordReset
        }),
        ...notificationsModule.mapActions({
            showError: NotificationsActions.NotifyError
        }),
        async submit(): Promise<void> {
            const validation = await (this.$refs.form as VForm).validate();
            if (!validation.valid) return;

            await this.requestPasswordReset({ email: this.email });
            this.informationDialog = true;
        },
        goToLoginPage(): void {
            this.$router.push(Routes.Login);
        }
    },
    watch: {
        errors(errors: string[] | null) {
            if (errors && errors.length > 0) {
                this.showError(errors);
            }
        }
    }
});
</script>
